import App from "@/app/App.tsx";
import { initAnalytics } from "@/infrastructure/analytics";
import { initMonitoring } from "@/infrastructure/monitoring";
import "@/infrastructure/i18n/i18n";
import "@/styles/main.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Initialize Sentry monitoring FIRST (before React)
initMonitoring();
initAnalytics();

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
